import React, { useMemo } from "react";
import "./Avatar.css";
import { OrbitProgress } from "react-loading-indicators";

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.split(" ");
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return parts[0][0].toUpperCase();
};

const generatePastelColor = (text) => {
  if (!text) return "#FFFFFF";
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Generate pastel color
  const h = hash % 360;
  return `hsl(${h}, 70%, 85%)`; // High lightness for pastel effect
};

const Avatar = ({
  user = null,
  name,
  size = 24,
  onClick = () => {},
  isLoading = false,
  ...props
}) => {
  const initials = useMemo(() => getInitials(name), [name]);
  const backgroundColor = useMemo(() => generatePastelColor(name), [name]);

  if (isLoading) {
    return (
      <div
        className="avatar"
        style={{
          backgroundColor,
          width: size,
          height: size,
          fontSize: size * 0.4,
        }}
        {...props}
      >
        <OrbitProgress color="#C1C7D4" />
      </div>
    );
  }

  if (user && user.avatar) {
    return (
      <div
        onClick={onClick}
        className="avatar"
        style={{
          backgroundColor,
          width: size,
          height: size,
          fontSize: size * 0.4,
          overflow: "hidden",
        }}
        {...props}
      >
        <img
          src={user.avatar}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className="avatar"
      style={{
        backgroundColor,
        width: size,
        height: size,
        fontSize: size * 0.4,
      }}
      {...props}
    >
      {initials}
    </div>
  );
};

export default Avatar;
